module.exports = __webpack_public_path__ + "images/help/icon-twr39-d3f64c12848bb4744bfb4444063f5e97.png";